import { Plus } from "lucide-react";
import { Button } from "@/shared/ui/button";

interface CategoryPanelHeaderProps {
  categoriesCount?: number;
  onCreateClick: () => void;
}

export function CategoryPanelHeader({
  categoriesCount,
  onCreateClick,
}: CategoryPanelHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-2xl font-semibold text-ink-900">
          Categories {categoriesCount !== undefined && `(${categoriesCount})`}
        </h2>
        <p className="mt-1 text-sm text-ink-600">
          Welcome to the categories page. Here you can manage the categories.
        </p>
      </div>
      <Button onClick={onCreateClick}>
        <Plus className="mr-2 h-4 w-4" />
        Add new category
      </Button>
    </div>
  );
}






